import React, {useRef} from "react";
import {getCustomerSlotDetails} from "../../services/SessionStorage";
import {Link} from "react-router-dom";
import {getThemeText} from "../../theme";
import {Tabs} from "../../falabella-components";
import {useTranslation} from "react-i18next";
import config from "../../../config";

const TabsMenu = ({path}) => {
  const {t} = useTranslation();
  const customerSlotDetails = useRef(getCustomerSlotDetails());
  // made changes in oofice links to hide covid questions.
  const officeLinks = {
    selectStore: t("office.tab.heading"),
    displayAppointments: t("displayAppointment.title"),
  };
  const nonTurneroEnabledLinks = {
    selectStore: t("login.label"),
    displayAppointments: t("displayAppointment.title"),
  };
  const turneroEnabledLinks = {
    selectTurneroStoreAndType: t("book.shift"),
    displayTurnero: t("displayTurneros.title"),
  };
  let active = 0;
  const links = customerSlotDetails.current.isOffice
    ? officeLinks
    : config.turnero_enabled_bu_list.includes(customerSlotDetails.current.bu)
    ? turneroEnabledLinks
    : nonTurneroEnabledLinks;
  const appointmentsSections = [
    "displayAppointments",
    "slotBooked",
    "displayTurnero",
  ];

  const setActive = (index) => {
    if (appointmentsSections.includes(path)) {
      return index;
    }
    return 0;
  };

  const tabs = Object.entries(links).map((k, i) => {
    active = setActive(i);
    return {
      tab: (
        <Link to={`/customer/${k[0]}`} className="p-4 w-full block">
          {k[1]}
        </Link>
      ),
    };
  });

  const theme = getThemeText(customerSlotDetails);

  return <Tabs contents={tabs} active={active} theme={theme} />;
};

export default TabsMenu;
